import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76f9e0ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spinner-overlay"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.model.showSpinner)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}